import { NavLink, useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import DraggAbleComponentView from "./DraggAbleComponentView";

function MergeTable() {
  const [componentList, setComponentList] = useState([]);
  const [tableCount, setTableCount] = useState(2);
  const [selectedTables, setSelectedTables] = useState({});
  const { id } = useParams();

  useEffect(() => {
    const data = localStorage.getItem("componentList");
    if (data) {
      setComponentList(JSON.parse(data));
    }
  }, []);
  

  const handleSelectChange = (index, value) => {
    setSelectedTables((prevSelected) => ({
      ...prevSelected,
      [index]: value,
    }));
  };


  function mergeTable(){
    // console.log(selectedTables)

    let mergeName = ""
    let mergeId = []
    


    for( let item in selectedTables){
        
      componentList.map((data)=>{
        if(data?.id == selectedTables[item]){
          if(mergeName == ""){
            mergeName = mergeName + data?.name;
            mergeId = [...mergeId, data?.id]
          }else{
            mergeName = mergeName + "+" + data?.name;
            mergeId = [...mergeId, data?.id]
          }
        }
      })

      // console.log(mergeName)
      // console.log(mergeId)
    }

    let mergeList  = componentList.map((item)=>{
      if(mergeId.includes(item?.id)){
        return({...item, mergedComponent:mergeId, mergedName:mergeName, isMerged:true})
      }else{
        return(item)
      }
    })

    // console.log(mergeList)


    let mergeTableList = [];

    if(localStorage.getItem("mergeTableList")){
      mergeTableList = JSON.parse(localStorage.getItem("mergeTableList"))
    }


    localStorage.setItem("mergeTableList", JSON.stringify([...mergeTableList, {id:`merge${Date.now()}`, name:mergeName, mergeId}]));
    localStorage.setItem("componentList", JSON.stringify(mergeList));

    setComponentList(mergeList);


  }




  return (
    <div className="w-screen h-screen bg-color1">
      <Layout>
        <div className="w-full h-full mt-1 flex">
          <div className="w-[76%] h-full bg-color1 flex flex-col">
            <div className="w-full h-[42px] border-color3 flex">
              <div className="w-[80%] relative">
                <NavLink
                  to={`/live-table/${id}`}
                  className={(e) =>
                    `w-[100px] absolute bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${
                      e.isActive ? "h-[42px]" : "h-[40px]"
                    } rounded-sm`
                  }
                >
                  Live Table
                </NavLink>
                <NavLink
                  to={`/edit-live-table/${id}`}
                  className={(e) =>
                    `w-[100px] h-[40px] absolute left-[120px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${
                      e.isActive ? "h-[42px]" : "h-[40px]"
                    } rounded-sm`
                  }
                >
                  Edit Table
                </NavLink>
                <NavLink
                  to={`/merge-live-table/${id}`}
                  className={(e) =>
                    `w-[100px] h-[40px] absolute left-[240px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${
                      e.isActive ? "h-[42px]" : "h-[40px]"
                    } rounded-sm`
                  }
                >
                  Merge Table
                </NavLink>
                <NavLink
                  to={`/separate-live-table/${id}`}
                  className={(e) =>
                    `w-[120px] h-[40px] absolute left-[360px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${
                      e.isActive ? "h-[42px]" : "h-[40px]"
                    } rounded-sm`
                  }
                >
                  Separate Table
                </NavLink>
              </div>

              <div className="w-[50%] flex items-center">
                <h1 className="text-xl text-color4 uppercase font-semibold">
                  Room {id}
                </h1>
              </div>
            </div>

            <div className="w-full h-full border-t border-color3">
              {componentList.map((data, index) => (
                <DraggAbleComponentView key={index} data={data} />
              ))}
            </div>
          </div>

          <div className="w-[24%] h-full bg-color2 p-2">
            <div className="min-h-[50%]">
              <h2 className="pb-2 text-center uppercase font-semibold text-color6 border-b border-color6">
                Merge Table
              </h2>

              <div className="px-10 mt-4 text-color4 text-lg flex gap-4 items-center">
                <label htmlFor="tableCount">Number of Tables </label>
                <input
                  onChange={(e) => {
                    setTableCount(Number(e.target.value));
                    setSelectedTables({}); // Reset selections on table count change
                  }}
                  type="number"
                  name="tableCount"
                  value={tableCount}
                  id="tableCount"
                  min={2}
                  className="w-[100px] py-1 px-1 bg-color3 text-color4 text-center border-none outline-none"
                />
              </div>

              <div className="  h-[200px] mt-4 overflow-y-auto">
                {Array.from({ length: tableCount }, (_, index) => (
                  <div key={index} className="px-10 text-lg text-color4 mt-4 flex gap-4">
                    <label htmlFor={`table-${index + 1}`}>
                      Table {index + 1}
                    </label>
                    <select
                      name={`table-${index + 1}`}
                      id={`table-${index + 1}`}
                      value={selectedTables[index] || ""}
                      onChange={(e) => handleSelectChange(index, e.target.value)}
                      className="w-[100px] py-1 px-1 bg-color3 text-color4 text-center border-none outline-none"
                    >
                      <option value="">Select A Table</option>
                      {componentList
                        .filter(
                          (data) =>
                            (!Object.values(selectedTables).includes(data?.id) ||
                            selectedTables[index] === data?.id) && !data.isMerged
                        )
                        .map((data) => (
                          <option key={data?.id} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                    </select>
                  </div>
                ))}
              </div>
                <div className=" my-4 pb-2 flex gap-4">
                    <button onClick={mergeTable} className=" w-full mt-4 py-1 bg-color7 rounded-md text-center">Save</button>
                    <button className=" w-full mt-4 py-1 bg-color8 rounded-md text-center">Cancel</button>
                </div>
            </div>

            <div>
              <h2 className="pb-2 text-center uppercase font-semibold text-color6 border-b border-color6">
                Merge Table List
              </h2>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default MergeTable;
